// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
import { RoomTypes } from '@weblite/ts-action/room'
import { ChatListToolboxOtherWappsModal } from '$comp/modals/chat-list-toolbox/chat-list-toolbox-other-wapps-modal'

const OTHER_WAPPS_COMPONENT_ID = 'chatListToolboxOtherWapps'

export const showChatListToolboxOtherWappsModal = async (
  roomType?: RoomTypes,
) => {
  addModal({
    id: OTHER_WAPPS_COMPONENT_ID,
    props: {
      roomType,
    },
  })
}

export default {
  [OTHER_WAPPS_COMPONENT_ID]: {
    Component: ChatListToolboxOtherWappsModal,
  },
}
